import SubLabel from "components/Atoms/Sublabel";
import PickerList from "components/Picker/PickerList";
import React from "react";
import { PickerListProps } from "../props";

const ProjectCodeList = (props: PickerListProps<server.dto.BusinessCentralProject>) => {
  const [instruction, setInstruction] = React.useState<server.dto.PaginatedBusinessCentralProjectInstruction>({
    keyword: "",
    visible: "onlyYes",
    page: 1,
    perPage: 15
  });

  return <PickerList
    instruction={instruction}
    onInstructionChange={setInstruction}
    queryKey="businessCentralProjects"
    api={window.CoreApi.BusinessCentral.ListProjects}
    onClick={props.onItemSelected}

    getError={(query) => query.data?.pages.flatMap(p => "errors" in p && p.errors).join(", ") ?? ""}

    getId={p => p.number}
    renderListItem={p => <>
      <div>{p.number}</div>
      <SubLabel>{p.name}</SubLabel>
    </>}

    filter1={{
      leftButton: {
        type: "primary",
        isActive: instruction.visible === "onlyYes",
        label: RESX.SoUser.Active,
        onClick: () => { setInstruction({ ...instruction, visible: "onlyYes" }); }
      },
      rightButton: {
        type: "primary",
        isActive: instruction.visible === "onlyNo",
        label: RESX.SoUser.Deactivated,
        onClick: () => { setInstruction({ ...instruction, visible: "onlyNo" }); }
      }
    }}
  />;
};

export default ProjectCodeList;